import React from 'react';
import IEmptyState from "EmptyState";

interface IEventItemProps {
    link: string;
    date: string;
    imageUrl: string
}

export default class EventItem extends React.Component<IEventItemProps, IEmptyState> {
    constructor(props: IEventItemProps) {
        super(props);
    }

    public render() {
        return (
            <div className="event">
                <a className="cover-picture" href={this.props.link}
                    target="_blank">
                    <img src={this.props.imageUrl} />
                </a>
                <div className="date">{this.props.date}</div>
            </div>
        );
    }
}